export default "__VITE_ASSET__4RxBbQd1__"